'use strict'

class Banner {

	closeButtonFn(el) {
		const baseClass = el.currentTarget.baseClass;
		const stickyBannerNode = document.querySelector(`.${baseClass}`);
		stickyBannerNode.classList.remove(`${baseClass}--animated`);
		stickyBannerNode.classList.add(`${baseClass}--hidden`);
		sessionStorage.setItem('dismiss_sticky_banner', 'yes');
		event.stopPropagation();
		event.preventDefault();
	}

	clickLinkFn(el) {
		window.open(el.currentTarget.href, '_blank').focus();
		sessionStorage.setItem('dismiss_sticky_banner', 'yes');
	}


	checkIfBannerIsDismissed() {
		return typeof sessionStorage.getItem('dismiss_sticky_banner') === 'string';
	}

	init() {

		if(window.backend.banner) {

			const headline = window.backend.banner.headline;
			const subline = window.backend.banner.subline;
			const url = window.backend.banner.url;

			// Check if is dismissed

			if(this.checkIfBannerIsDismissed()) {
				return false;
			}


			// config

			const baseClass = 'stickyBanner';
			const showDelay = 4500;


			// create elements
			const app = document.querySelector('body');


			const stickyBannerNode = document.createElement("div");
			const innerContainerNode = document.createElement("a");
			const textContainer = document.createElement("div");

			const textNode =  document.createElement("div");

			textNode.innerHTML  = `<strong>${headline}</strong><br><span class="stickyBanner__fontSmaller"></strong> <u>${subline}</span>`;
			const closeButton = document.createElement("button");


			// add classes

			stickyBannerNode.classList.add(`${baseClass}`,`${baseClass}--hidden`);
			innerContainerNode.classList.add(`${baseClass}__innerContainer`);
			innerContainerNode.href = url;
			innerContainerNode.target = '_blank';
			closeButton.classList.add(`${baseClass}__closeButton`);
			textContainer.classList.add(`${baseClass}__textContainer`);


			// create structure

			textContainer.appendChild(textNode);
			innerContainerNode.appendChild(textContainer);
			stickyBannerNode.appendChild(innerContainerNode);
			innerContainerNode.appendChild(closeButton);
			app.append(stickyBannerNode);


			// create binding

			closeButton.baseClass = baseClass;
			innerContainerNode.baseClass = baseClass;
			closeButton.addEventListener('click', this.closeButtonFn);
			innerContainerNode.addEventListener('click', (el) => {
				this.clickLinkFn(el);
				this.closeButtonFn(el);
			});

			// start animation

			setTimeout(function() {
				stickyBannerNode.classList.remove(`${baseClass}--hidden`);
				stickyBannerNode.classList.add(`${baseClass}--animated`);
			}, showDelay);



		}

	}
}
